import React from 'react';
import { Button, ButtonGroup } from '@mui/material';
import { MachineConfigRowState } from './ConfigModal';

interface OnOffButtonGroupProps {
    row: MachineConfigRowState;
    index: number;
    handleButtonGroupChange: (index: number, newState: "ON" | "OFF" | "NEW") => void;
    disabled?: boolean;
}

const MachineOnOffButtonGroup: React.FC<OnOffButtonGroupProps> = ({ row, index, handleButtonGroupChange, disabled }) => {
    return (
        <ButtonGroup variant="outlined" aria-label="On/Off button group">
            <Button
                onClick={() => handleButtonGroupChange(index, 'ON')}
                variant={row.onOff === 'ON' ? 'contained' : 'outlined'}
                disabled={disabled}
            >
                On
            </Button>
            <Button
                onClick={() => handleButtonGroupChange(index, 'OFF')}
                variant={row.onOff === 'OFF' ? 'contained' : 'outlined'}
                disabled={disabled}
            >
                Off
            </Button>
            <Button
                onClick={() => handleButtonGroupChange(index, 'NEW')}
                variant={row.onOff === 'NEW' ? 'contained' : 'outlined'}
                disabled={disabled || row.onOff === "ON" || row.onOff === "OFF"}
            >
                New
            </Button>
        </ButtonGroup>
    );
};

export default MachineOnOffButtonGroup;
